import { observer } from 'mobx-react';
import React from 'react';
import ParticipantsStore from '../../../../../../ParticipantsStore';
import Modal from '../../../../../Modal';
import ModalStore from '../../../../../Modal/Store';
import ReclaimLicensesStore from '../Store';
import FormState from './FormState';
import Header from './Header';
import ReclaimLicensesReactions from './Reactions';

interface Props {
  store: ParticipantsStore;
  modalStore: ModalStore;
}

export const resetModal = (modalStore: ModalStore, reclaimLicensesStore: ReclaimLicensesStore) => {
  modalStore.close();
  reclaimLicensesStore.ready();
};
function ReclaimLicensesModal({ store, modalStore }: Props) {
  const reclaimLicensesStore = React.useRef(new ReclaimLicensesStore(store)).current;
  switch (modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <>
          <Modal
            close={() => resetModal(modalStore, reclaimLicensesStore)}
            title={<Header reclaimLicensesStore={reclaimLicensesStore} />}
            modalWidth="overflow-y-auto w-2/5"
            customBackgroundCssClasses="bg-teal-100 opacity-60"
          >
            <FormState
              participantsStore={store}
              modalStore={modalStore}
              reclaimLicensesStore={reclaimLicensesStore}
            />
          </Modal>
          <ReclaimLicensesReactions store={reclaimLicensesStore} fireImmediately={true} />
        </>
      );
  }
}

export default observer(ReclaimLicensesModal);
